import * as AWS from 'aws-sdk/global';
import { Amplify } from 'aws-amplify';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import fr from '@angular/common/locales/fr';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from 'src/environments/environment';
import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, enableProdMode, importProvidersFrom } from '@angular/core';
import { Router, provideRouter, withComponentInputBinding } from '@angular/router';
import { APP_ROUTES } from './app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { createSentryCustomErrorHandler } from './sentry-custom-error-handler';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';

AWS.config.update({
  region: environment.AWS_REGION,
  maxRetries: 1,
  httpOptions: {
    timeout: 0,
    connectTimeout: 2000,
  },
});

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: environment.IDENTITY_POOL_ID,
      userPoolId: environment.USER_POOL_ID,
      userPoolClientId: environment.USER_POOL_WEB_CLIENT_ID,
    },
  },
  API: {
    REST: {
      api: {
        region: environment.AWS_REGION,
        endpoint: environment.API_URL,
      },
      'fdm-api': {
        region: environment.AWS_REGION,
        endpoint: environment.FDM_API_URL,
      },
    },
  },
  Storage: {
    S3: {
      bucket: environment.RESTRICTED_BUCKET,
      region: environment.AWS_REGION,
    },
  },
});

registerLocaleData(en);
registerLocaleData(es);
registerLocaleData(fr);

Sentry.init({
  dsn: environment.SENTRY_DSN,
  transportOptions: {
    maxQueueSize: 100,
  },
  environment: environment.sentry_env,
  ignoreErrors: ['Non-Error exception captured'],
  tracesSampleRate: 0,
  enabled: true,
});

if (environment.production) {
  enableProdMode();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: createSentryCustomErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    }, // we only use Sentry in production see also main.ts
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => (): void => {
        //
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    importProvidersFrom(BrowserModule, AmplifyAuthenticatorModule, BrowserAnimationsModule),
    provideAnimations(),
  ],
};
